import { ThemeName } from '@/types/styles/ThemeName'
import { createContext, Dispatch, SetStateAction } from 'react'

export const ChosenThemeActionContext = createContext<Dispatch<SetStateAction<ThemeName | undefined>>>(() => {});

export default ChosenThemeActionContext;